import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { guideSteps } from '../data/guideSteps';
export function GuideHero() {
  return <header className="mx-auto w-full max-w-7xl px-6 pb-16 pt-16 lg:px-10 lg:pb-24 lg:pt-24" data-id="element-17" data-mp="wynh29coqh8q">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-18" data-mp="s1oldmddi28f">
        <div className="lg:col-span-7" data-id="element-19" data-mp="n2kbsumje2hk">
          <p className="text-sm font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-20" data-mp="n3n0qx0atuuu">
            Almenr × Flex Funding
          </p>
          <h1 className="mt-5 max-w-2xl text-4xl font-extrabold leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl" data-id="element-21" data-mp="1fqpy3lt8nzji">
            Kom godt i gang som investor
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-muted" data-id="element-22" data-mp="1athfjk46hthq">
            Simple trin fra oprettelse til din første investering i Almenrs
            bofællesskaber – via Flex Fundings platform. Sæt ca. 15 minutter af.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-23" data-mp="3rg0mym619i2d">
            <a href="https://portal.flexfunding.com/signup?partner=almenr" className="inline-flex items-center gap-2 rounded-full bg-brand px-7 py-4 text-base font-bold text-white transition-colors duration-150 ease-smooth hover:bg-brand-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand" data-id="element-24" data-mp="1fnr0o2jpgsyq">
              Opret investeringskonto
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="wwzoyuc8wqh6" />
            </a>
            <a href="#opret-konto" className="inline-flex items-center rounded-full border border-ink/15 px-7 py-4 text-base font-bold text-ink transition-colors duration-150 ease-smooth hover:border-ink/40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand" data-id="element-26" data-mp="11ohpxie9qr25">
              Læs guiden
            </a>
          </div>
        </div>

        <div className="lg:col-span-5" data-id="element-27" data-mp="iw6prwb0177q">
          <nav aria-label="Trin i guiden" className="rounded-4xl bg-forest p-8 text-white lg:p-10" data-id="element-28" data-mp="izazf978gv5s">
            <h2 className="text-sm font-semibold uppercase tracking-[0.14em] text-lime" data-id="element-29" data-mp="2fvp5be6l62rm">
              Guiden på seks trin
            </h2>
            <ol className="mt-6 divide-y divide-white/10" data-id="element-30" data-mp="2ax453erc3j36">
              {guideSteps.map(step => <li key={step.id} data-id="element-31" data-mp="26x3pvrwev3v2">
                  <a href={`#${step.id}`} className="group flex items-baseline gap-4 py-3.5 transition-opacity duration-150 ease-smooth hover:opacity-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-lime" data-id="element-32" data-mp="33l9o9x2qp00w">
                    <span className="text-sm font-semibold tabular-nums text-white/40" data-id="element-33" data-mp="2pmjqsgc0cyc0">
                      {step.number}
                    </span>
                    <span className="text-base font-medium text-white/85 transition-colors duration-150 ease-smooth group-hover:text-lime" data-id="element-34" data-mp="1j3lkoeiduyxo">
                      {step.title}
                    </span>
                  </a>
                </li>)}
            </ol>
            <a href="#nyhedsbrev" className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-lime underline-offset-4 transition-colors duration-150 ease-smooth hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-lime" data-id="element-35" data-mp="3utjm7de7n6gs">
              Nye lån går hurtigt – få besked på mail
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-36" data-mp="hcu3cpf6egwf" />
            </a>
          </nav>
        </div>
      </div>
    </header>;
}